import React from 'react';
import Login from '../Login/Login';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import './Auth.css';
import { Link as Anchor } from 'react-router-dom';
import { useLogo } from '../../LogoContext';
import { ruta } from '../../paths';
export default function Auth() {
    const { logo } = useLogo();
    return (
        <div className='AuthContainer'>
            <Anchor to={ruta('/')} >
                <img src={logo} alt="Efecto Vial" className='logoAtuh' />
            </Anchor>

            <Login />

            <Anchor to={ruta('/')} className='btnVolverInicio'>
                <FontAwesomeIcon icon={faHome} /> Volver al inicio
            </Anchor>
        </div>
    );
}
